<template>
  <div class="spinner-container">
    <Spinner/>
  </div>
</template>

<script>
import Spinner from '@/components/shared/spinner/Spinner';

export default {
  name: 'AppFallback',
  components: {
    Spinner
  },
  mounted () {
    this.openApp();
  },
  methods: {
    openApp () {
      const fallbackUrl = this.getStoreUrl();
      // Fallback url will be current url but replacing /app
      const webFallbackUrl = window.location.href.replace('/app', '');

      if (this.isIOS()) {
        window.location = fallbackUrl;
      } else if (this.isAndroid()) {
        window.location = fallbackUrl;
      } else {
        window.location = webFallbackUrl;
      }
    },
    getStoreUrl () {
      if (this.isIOS()) {
        return 'https://apps.apple.com/es/app/glucovibes/id1570464962'; // Replace with your app's App Store URL
      }
      if (this.isAndroid()) {
        return 'https://play.google.com/store/apps/details?id=com.xugarhero.glucovibes'; // Replace with your app's Play Store URL
      }
      // Default fallback URL
      return window.location.href.replace('/app', '');
    },
    isIOS () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    },
    isAndroid () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android/i.test(userAgent);
    }
  }
};

</script>

<style lang="scss">
@import "src/stylesheets/variables";

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/AppFallback.vue